import { cn } from "app/lib/utils"
import { Dispatch, SetStateAction } from "react"
import PlayerIcon from "./PlayerIcon"

type Props<T extends { type: unknown }> = {
  options: T[]
  data: { type: T["type"]; text: string; subText?: string; chevron?: boolean }[]
  setOption: Dispatch<SetStateAction<T["type"]>>
  selectedOption: T["type"]
  onOptionSelect?: () => void
}

export default function PlayerDropdownOptions<T extends { type: unknown }>({
  data,
  options,
  setOption,
  selectedOption,
  onOptionSelect,
}: Props<T>) {
  return (
    <>
      {options.map((item) => {
        const dataElement = data.find((el) => el.type === item.type)
        const text = dataElement?.text
        const isSelected = selectedOption === item.type

        return (
          <button
            key={String(item.type)}
            type="button"
            className={cn(
              "flex h-12 w-full shrink-0 items-center justify-between gap-3 rounded px-3 text-left text-md font-normal text-white transition-colors",
              "hover:bg-[linear-gradient(rgba(255,255,255,0.1),rgba(255,255,255,0.1)),linear-gradient(#02002a,#02002a)]",
              "active:bg-[linear-gradient(rgba(255,255,255,0.2),rgba(255,255,255,0.2)),linear-gradient(#02002a,#02002a)]"
            )}
            onClick={() => {
              setOption(item.type)
              onOptionSelect?.()
            }}
          >
            {text && <span className="whitespace-nowrap">{text}</span>}
            <span className="inline-flex size-6 shrink-0 items-center justify-center">
              {isSelected && (
                <PlayerIcon
                  src="/icons/player/thick/ico_check_thin.svg"
                  size={24}
                />
              )}
            </span>
          </button>
        )
      })}
    </>
  )
}
